"use client";
import { Section } from "../ui/section";
import { useTranslation } from "@/lib/i18n";
import {
    ShieldCheckIcon,
    LockKeyholeIcon,
    ScaleIcon,
    FileCheckIcon,
    GlobeIcon,
    BrainCircuitIcon,
    BuildingIcon,
} from "lucide-react";

const frameworks = [
    { name: "ISO 27001", icon: ShieldCheckIcon },
    { name: "SOC 2", icon: LockKeyholeIcon },
    { name: "GDPR", icon: ScaleIcon },
    { name: "EU AI Act", icon: BrainCircuitIcon },
    { name: "NDMO", icon: BuildingIcon },
    { name: "NIST CSF", icon: FileCheckIcon },
    { name: "HIPAA", icon: GlobeIcon },
];

export default function Logos() {
  const { t } = useTranslation("common");
    return (
        <Section className="md:py-16" id="frameworks">
            <div className="mx-auto flex max-w-container flex-col items-center gap-8 text-center">
                <div className="flex flex-col items-center gap-6">
                    <h2 className="text-md font-semibold sm:text-2xl">
                        {t("logos.title")}
                    </h2>
                </div>
                <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10">
                    {frameworks.map((fw) => (
                        <div
                            key={fw.name}
                            className="flex items-center gap-2 rounded-lg glass-4 px-4 py-2.5 text-sm font-medium text-muted-foreground transition-all hover:text-foreground hover:shadow-md"
                        >
                            <fw.icon className="h-5 w-5 text-aicompliance-foreground" />
                            {fw.name}
                        </div>
                    ))}
                </div>
            </div>
        </Section>
    );
}
